import React from 'react';

const Copyright = () => {
  return (
    <footer className="bg-[#522258] text-white text-center md:py-4 py-6">
      <p className="text-xs">
        &copy; {new Date().getFullYear()} Malaiappansrikanth. All rights reserved.
      </p>
    </footer>
  );
};

export default Copyright;
